import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import validators from "shared/validators";
import "./CategoryList.scss"
import { CityAndStateService, LocationService } from "shared/services";
import { CustomDatePicker } from "./CategoryFilter";
import moment from "moment";
import { addDataLayer } from "shared/utils/utils";
export default function ExploreFilterUI({ filterData, onApply, resetFilter }) {
    const category = useSelector(state => state?.category);
    const [filterinput, setfilterinput] = useState({
        zipcode: { value: '', error: '', validators: [validators.equalToLength(5)] },
        miles: { value: '', error: '', validators: [validators.required()] },
        min: { value: '', error: '', validators: [] },
        max: { value: '', error: '', validators: [] },
        startdate: { value: '', error: '', validators: [] },
        enddate: { value: '', error: '', validators: [] },
        categoryGroup: { value: '', error: '', validators: [] },
        category: { value: '', error: '', validators: [] },
        locationid: { value: '', error: '', validators: [] },
        itemtype: { value: [], error: '', validators: [] },
        state: { value: '', error: '', validators: [] },
        keyword: { value: '', error: '', validators: [] },
        area: { value: '', error: '', validators: [] },
    })
    const [errors, seterrors] = useState({})

    const [subCategory, setsubCategory] = useState([])
    const [locationlist, setlocationlist] = useState([])
    const [stateList, setstateList] = useState([])
    const [width, setwidth] = useState(window?.innerWidth)

    useEffect(async () => {
        setValue(filterData)
        await getLocations()
        await getStateList()

        return () => {

        }
    }, [filterData])
    const setValue = (filtervalue) => {
        let data = { ...filterinput }
        Object.keys(data).map((item) => {
            if (item in filtervalue) {
                data[item]["value"] = filtervalue?.[item]
            } else {
                data[item]["value"] = item == "itemtype" ? [] : ""
            }
        })
        setfilterinput(data)
    }

    const getLocations = async () => {
        const payload = {
            "sort": [{ "field": "title", "direction": "asc" }],
            "field": ["id", "title"]
        };
        await LocationService.getLocationList(payload).then((response) => {
            let list = response?.data?.data
            setlocationlist(list)
        })
            .catch(error => {
            });
    }
    const getStateList = async () => {
        await CityAndStateService.getStateList().then((response) => {
            let list = response?.data?.data
            setstateList(list)
        })
    }
    const onInputValidation = (event, key = "itemtype") => {
        if (event.target?.name == "categoryGroup") {
            let index = category.findIndex(i => i.label == event.target.value)
            if (index >= 0) {
                setsubCategory(category[index].subCategory)
            }
        }
        let filterData = filterinput
        if (key == "date") {
            if ((moment(event.value)).isSameOrBefore(moment())) {
                filterData[event.name]["error"] = `${event.name == "startdate" ? "Start" : "End"} date time should be greater than the current time`;
            }
            filterData[event.name]["value"] = event.value
        } else {
            if (event.target.name === 'zipcode') {
                if (isNaN(Number(event.target.value)))
                    event.target.value = '';
            }
            if (event.target.name === 'min' || event.target.name === 'max') {
                if (isNaN(Number(event.target.value)))
                    event.target.value = filterData?.[event.target.name]?.["value"];
            }
            if (event.target.name === 'keyword') {
                let exp = /^[a-zA-Z0-9!@#$%^&* ]+$/g;
                if(!exp.test(event.target.value) && event.target.value  != "") {
                    event.target.value = filterData?.[event.target.name]?.["value"]
                }
            }
            if (event.target.type == "checkbox") {
                if (key === "itemtype") {
                    if (!filterData[key]["value"].includes(event.target.name)) {
                        filterData[key]["value"].push(event.target.name)
                        if (event.target.name == "directBuy") {
                            filterData[key]["value"] = filterData[key]["value"].filter(item => (!(item == "auction" || item == "buynow")))
                        } else if (event.target.name == "auction" || event.target.name == "buynow") {
                            filterData[key]["value"] = filterData[key]["value"].filter(item => (item != "directBuy"))
                        } else if (event.target.name == "isshippable") {
                            filterData[key]["value"] = filterData[key]["value"].filter(item => (item != "pickuponly"))
                        } else if (event.target.name == "pickuponly") {
                            filterData[key]["value"] = filterData[key]["value"].filter(item => (item != "isshippable"))
                        }
                    } else {
                        filterData[key]["value"].splice(filterData[key]["value"]?.indexOf(event.target.name), 1)
                    }
                } else {
                    filterData[key]["value"] = event.target.checked ? event.target.name : ""
                }
            }
            else {
                filterData[event.target.name]["value"] = event.target.value
            }
        }
        setfilterinput({ ...filterData })
        if (event?.target?.value?.length === 5 && event?.target?.name === 'zipcode' && !isNaN(Number(event?.target?.value))) {
            getStateListForZipcode(event.target.value)
        }

    }
    const getStateListForZipcode = (value) => {
        CityAndStateService.getZipCodeDeatils(value).then((resp) => {
            let data = resp?.data?.data?.[0] || {}
            setfilterinput((prevState) => {
                prevState["state"]["value"] = data?.state
                return { ...prevState }
            })


        }).catch(error => {
        });
    }
    const applyfilter = (filter) => {
        let error = {}
        if (filterinput?.min?.value != "" && filterinput?.max?.value != "") {
            if (!(parseFloat(filterinput?.min?.value) <= parseFloat(filterinput?.max?.value))) {
                error["price"] = "Max value should be greater than min value"
            }
        }
        if (filterinput?.startdate?.value != "" && filterinput?.enddate?.value != "") {
            let start = moment(filterinput?.startdate?.value)
            let end = moment(filterinput?.enddate?.value)
            if (moment(start).isSameOrAfter(moment(end))) {
                error["date"] = "Start time should not be greater than or equal to end time";
            }
        }
        seterrors(error)
        if (!(Object.keys(error).length > 0)) {
            let filtervalues = {
                zipcode: filterinput?.zipcode?.value,
                miles: filterinput?.miles?.value,
                min: filterinput?.min?.value,
                max: filterinput?.max?.value,
                startdate: filterinput?.startdate?.value,
                enddate: filterinput?.enddate?.value,
                categoryGroup: filterinput?.categoryGroup?.value,
                category: filterinput?.category?.value,
                itemtype: filterinput?.itemtype?.value,
                keyword: filterinput?.keyword?.value,
                locationid: filterinput?.locationid?.value,
                state: filterinput?.state?.value,
            }
            filtervalues = { ...filtervalues, ...filter }
            onApply(filtervalues)
        }
        let dataLayerData = {
            'event': 'explore_listing',
        }
        addDataLayer(dataLayerData);
    }
    return (
        <div className="w-100 category-mainmodal">
            <div className="halfinput my-2">
                <Form.Group className="inputcont" >
                    <Form.Label>Location</Form.Label>
                    <Form.Select as="select" name="locationid" value={filterinput?.locationid?.value} onChange={(event) => { onInputValidation(event) }}>
                        <option value="All">All Locations</option>
                        {
                            locationlist.map(loc =>
                                <option value={loc.id} key={loc.title}>{loc.title}</option>
                            )
                        }
                    </Form.Select>
                </Form.Group>
            </div>
            <div className="d-flex w-100 my-2">
                <Form.Group className="inputcont">
                    <Form.Label>Zip code</Form.Label>
                    <Form.Control type="text" maxLength={5} placeholder="Enter Zip code" aria-label='Enter zipcode' name="zipcode" value={filterinput.zipcode.value} onChange={(event) => onInputValidation(event)} />
                    {
                        filterinput.zipcode.value && filterinput.zipcode.error ? <small className="text-danger">{filterinput.zipcode.error}</small> : null
                    }
                </Form.Group>
                <Form.Group className="inputcont">
                    <Form.Label>State</Form.Label>
                    <Form.Select as="select" name="state" value={filterinput?.state?.value} onChange={(event) => { onInputValidation(event) }}>
                        <option value="All">All State</option>
                        {
                            stateList.map(loc =>
                                <option value={loc.state} key={loc.state}>{loc.state}</option>
                            )
                        }
                    </Form.Select>
                </Form.Group>
                <Form.Group className="inputcont">
                    <Form.Label>Within the radius of</Form.Label>
                    <Form.Select role={"button"} as="select" placeholder="Select Distance" aria-label='Select Distance' name="miles" value={filterinput.miles.value} onChange={(event) => onInputValidation(event)}>
                        <option selected hidden>Select Distance</option>
                        <option value="5">5 Miles</option>
                        <option value="10">10 Miles</option>
                        <option value="25">25 Miles</option>
                        <option value="50">50 Miles</option>
                        <option value="100">100 Miles</option>
                        <option value="250">250 Miles</option>
                    </Form.Select>
                </Form.Group>
            </div>
            <div className="borderui my-4"></div>
            <div className="d-flex w-100 my-2">
                <Form.Group className="inputcont">
                    <Form.Label>Category</Form.Label>
                    <Form.Select as="select" name="categoryGroup" value={filterinput?.categoryGroup?.value} onChange={(event) => { onInputValidation(event) }}>
                        <option value="All">All Category</option>
                        {
                            category.map(cat =>
                                <option value={cat.label} key={cat.label}>{cat.label}</option>
                            )
                        }
                    </Form.Select>
                </Form.Group>
                <Form.Group className="inputcont">
                    <Form.Label>Subcategory</Form.Label>
                    <Form.Select as="select" name="category" value={filterinput?.category?.value} onChange={(event) => { onInputValidation(event) }}>
                        <option value="All">All Sub Category</option>
                        {
                            subCategory.map(scat =>
                                <option value={scat.label} key={scat.label}>{scat.label}</option>
                            )
                        }
                    </Form.Select>
                </Form.Group>
            </div>
            <div className="halfinput">
                <Form.Group className="inputcont">
                    <Form.Label>Keywords</Form.Label>
                    <Form.Control type="text" placeholder="Search all of these words" aria-label='Search all of these words' name="keyword" value={filterinput.keyword.value} onChange={(event) => onInputValidation(event)} />
                    {
                        filterinput.keyword.value && filterinput.keyword.error ? <small className="text-danger">{filterinput.keyword.error}</small> : null
                    }
                </Form.Group>
            </div>
            <Form.Group className="inputcont my-2 rowviewcont">
                <Form.Label>Price Range</Form.Label>

                <Form.Group className="d-flex gap-2 align-items-center">
                    <Form.Control type="text" placeholder="$ min" aria-label='$ mine' name="min" value={filterinput.min.value} onChange={(event) => onInputValidation(event)} />
                    {
                        filterinput.min.value && filterinput.min.error ? <small className="text-danger">{filterinput.min.error}</small> : null
                    }
                    <div>-</div>
                    <Form.Control type="text" placeholder="$ max" aria-label='$ maxe' name="max" value={filterinput.max.value} onChange={(event) => onInputValidation(event)} />
                    {
                        filterinput.max.value && filterinput.max.error ? <small className="text-danger">{filterinput.max.error}</small> : null
                    }
                </Form.Group>
                {errors?.["price"] && <small className="text-danger">{errors?.["price"]}</small>}
            </Form.Group>
            <div className="borderui my-4"></div>
            <div className="inputcont my-2 rowviewcont" >
                <Form.Label>Date From</Form.Label>
                <div className="d-flex gap-2 ">
                    <CustomDatePicker
                        value={filterinput.startdate.value}
                        label="Start Date"
                        onchange={(date) => { onInputValidation({ value: date, name: "startdate" }, "date") }}
                        id={"expfilter_startdate"}
                    />
                    <CustomDatePicker
                        value={filterinput.enddate.value}
                        label="End Date"
                        onchange={(date) => { onInputValidation({ value: date, name: "enddate" }, "date") }}
                        mindate={moment(filterinput.startdate.value).add(1, 'days').toDate()}
                        id={"expfilter_enddate"}
                    />
                </div>
                {errors?.["date"] && <small className="text-danger">{errors?.["date"]}</small>}
            </div>
            <div className="borderui my-4"></div>
            <Form.Group className="inputcont">
                <Form.Label>Option</Form.Label>
                <div className="d-flex flex-wrap gap-2">
                    <Form.Group className="multiple-checkbox">
                        <Form.Check custom type="checkbox" id="auction" name="auction" label="Auction" checked={filterinput?.itemtype?.value.includes("auction")} onChange={(event) => { onInputValidation(event) }} />
                    </Form.Group>
                    <Form.Group className="multiple-checkbox">
                        <Form.Check custom type="checkbox" id="directbuy" name="directBuy" label="Direct buy" checked={filterinput?.itemtype?.value.includes("directBuy")} onChange={(event) => { onInputValidation(event) }} />
                    </Form.Group>
                    <Form.Group className="multiple-checkbox">
                        <Form.Check custom type="checkbox" id="buy-now" name="buynow" label="Buy Now" checked={filterinput?.itemtype?.value.includes("buynow")} onChange={(event) => { onInputValidation(event) }} />
                    </Form.Group>
                    <Form.Group className="multiple-checkbox">
                        <Form.Check custom type="checkbox" id="isshippable" name="isshippable" label="Shippable" checked={filterinput?.itemtype?.value.includes("isshippable")} onChange={(event) => { onInputValidation(event) }} />
                    </Form.Group>
                    <Form.Group className="multiple-checkbox">
                        <Form.Check custom type="checkbox" id="pickuponly" name="pickuponly" label="Pick Up Only" checked={filterinput?.itemtype?.value.includes("pickuponly")} onChange={(event) => { onInputValidation(event) }} />
                    </Form.Group>
                    <Form.Group className="multiple-checkbox">
                        <Form.Check disabled={filterinput?.categoryGroup.value == "" && filterinput?.locationid.value == ""} custom type="checkbox" id="completed" name="completed" label="Completed (Location or Category selection is required)" checked={filterinput?.itemtype?.value.includes("completed")} onChange={(event) => { onInputValidation(event) }} />
                    </Form.Group>

                </div>
            </Form.Group>
            <div className="borderui my-4"></div>
            <div className="d-flex gap-2 pb-2">
                <Button onClick={() => {
                    setValue({})
                }} className="btn-grey">Reset</Button>
                <Button onClick={() => {
                    applyfilter({})
                }} className="btn-secondary">Find Items</Button>
            </div>
        </div>
    )
}